import { ExternalRedirectRoute } from '../Routing/types';
const redirects: ExternalRedirectRoute[] = [
  {
    path: '/contact',
    externalRedirectTo: 'https://raize.zendesk.com/hc/en-us',
  },
];

export default redirects;
